
<template>

<el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="收费统计" name="first" :lazy="true" >
        <free-statistics ref="free-statistics"  v-belong-to-admin></free-statistics>
    </el-tab-pane>
    <el-tab-pane label="收费记录" name="second" >
      <free-order-management  ref="free-order-management"  v-belong-to-admin></free-order-management>
    </el-tab-pane>
    <el-tab-pane label="收费设置" name="third"  v-if="userInfo.employeeAccount=='admin'||userInfo.employeeAccount=='SXB0024'" >
      <private-used-car-config ref="private-used-car-config"  v-belong-to-admin></private-used-car-config>
    </el-tab-pane>
</el-tabs>

</template>

<script>

import BasicPager from '@/mixins/BasicPager'
import FreeStatistics from './FreeStatistics'
import freeOrderManagement from './freeOrderManagement'
import privateUsedCarConfig from './privateUsedCarConfig'
export default {
  name: 'private-tab-index',
  extends: BasicPager,
  data () {
    return {
      isAdmin: false,
      activeName: 'first',
      userInfo: null
    }
  },
  mounted: function () {
    let userInfo = JSON.parse(localStorage.userInfo)
    this.userInfo = userInfo
    this.isAdmin = userInfo.loginPath != 'channel'
    this.$refs['free-statistics'].selectStatistics()
  },
  components: {
    FreeStatistics,
    freeOrderManagement,
    privateUsedCarConfig
  },
  methods: {
    handleClick (tab, event) {
      let that = this
      switch (tab.index) {
        case '0':
          that.$refs['free-statistics'].selectStatistics()
          break
        case '1':
          that.$refs['free-order-management'].loadList(1)

          break
        case '2':
          that.$refs['private-used-car-config'].loadUsedCarConfigSourceData()

          break
        default:
      }
    }
  }
}

</script>
